module.exports = __webpack_public_path__ + "img/paraguay.f1e07efa.png";